var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResidentAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.05859C3 6.11946 3.42143 7.13688 4.17157 7.88702C4.92172 8.63717 5.93913 9.05859 7 9.05859C8.06087 9.05859 9.07828 8.63717 9.82843 7.88702C10.5786 7.13688 11 6.11946 11 5.05859C11 3.99773 10.5786 2.98031 9.82843 2.23017C9.07828 1.48002 8.06087 1.05859 7 1.05859C5.93913 1.05859 4.92172 1.48002 4.17157 2.23017C3.42143 2.98031 3 3.99773 3 5.05859Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.0586V17.0586C1 15.9977 1.42143 14.9803 2.17157 14.2302C2.92172 13.48 3.93913 13.0586 5 13.0586H9C10.0609 13.0586 11.0783 13.48 11.8284 14.2302C12.5786 14.9803 13 15.9977 13 17.0586V19.0586",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.1875C14.8604 1.4078 15.623 1.9082 16.1676 2.60981C16.7122 3.31142 17.0078 4.17433 17.0078 5.0625C17.0078 5.95067 16.7122 6.81358 16.1676 7.51519C15.623 8.2168 14.8604 8.7172 14 8.9375",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.057V17.057C18.9949 16.1742 18.6979 15.3178 18.1553 14.6214C17.6126 13.925 16.8548 13.4277 16 13.207",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentAppIcon);
export default __webpack_public_path__ + "static/media/resident-app-icon.35f12e9abbf2ec47d5402d31795162e3.svg";
export { ForwardRef as ReactComponent };